/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sub_Billing_Bills_OnInputs */



/**
* | output |
* | --- |
* | "Bills on {date}" |
*
* @param {Sub_Billing_Bills_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_billing_bills_on = /** @type {((inputs: Sub_Billing_Bills_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Billing_Bills_OnInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Fällig am ${i?.date}`)
	return /** @type {LocalizedString} */ (`Bills on ${i?.date}`)
});